import { FormField, FormFieldRow, ReadOnlyField } from '@msaf/core-react'
import { TOOLTIP } from '../../../../constants/tooltips'
import { AquiferViewFormInterface } from './aquifer-test-details-view'
import { AquiferTestObservationWellsViewFormInterface } from './aquifer-test-observation-wells-view'

export function TestFieldsView({
  isLoading,
  fields,
  index,
}: AquiferTestObservationWellsViewFormInterface & AquiferViewFormInterface) {
  return (
    <>
      <FormFieldRow>
        <FormField
          toolTipMessage={TOOLTIP.transmissivity}
          isSkeleton={isLoading}
          label='Transmissivity (m2/d)'
          labelId={`transmissivityLabel${index}`}
        >
          <ReadOnlyField
            isSkeleton={isLoading}
            labelledBy={`transmissivityLabel${index}`}
            value={`${fields.transmissivity ?? ''}`}
          />
        </FormField>

        <FormField
          isSkeleton={isLoading}
          label='Overlying aquifer - transmissivity (m2/d)'
          labelId={`transmissivityOverlyingLayerLabel${index}`}
        >
          <ReadOnlyField
            isSkeleton={isLoading}
            labelledBy={`transmissivityOverlyingLayerLabel${index}`}
            value={`${fields.transmissivityOverlyingLayer ?? ''}`}
          />
        </FormField>
      </FormFieldRow>
      <FormFieldRow>
        <FormField
          toolTipMessage={TOOLTIP.storativity}
          isSkeleton={isLoading}
          label='Storativity'
          labelId={`storativityLabel${index}`}
        >
          <ReadOnlyField
            isSkeleton={isLoading}
            labelledBy={`storativityLabel${index}`}
            value={`${fields.storativity ?? ''}`}
          />
        </FormField>

        <FormField
          isSkeleton={isLoading}
          label='Overlying aquifer - storativity'
          labelId={`storativityOverlyingLayerLabel${index}`}
        >
          <ReadOnlyField
            isSkeleton={isLoading}
            labelledBy={`storativityOverlyingLayerLabel${index}`}
            value={`${fields.storativityOverlyingLayer ?? ''}`}
          />
        </FormField>
      </FormFieldRow>

      <FormField
        toolTipMessage={TOOLTIP.aquiferTestDrawdown}
        isSkeleton={isLoading}
        label='Drawdown'
        labelId={`drawdown${index}`}
      >
        <ReadOnlyField isSkeleton={isLoading} labelledBy={`drawdown${index}`} value={`${fields.drawdown ?? ''}`} />
      </FormField>

      <FormField
        toolTipMessage={TOOLTIP.leakage}
        isSkeleton={isLoading}
        label='Leakage (m)'
        labelId={`leakage${index}`}
      >
        <ReadOnlyField isSkeleton={isLoading} labelledBy={`leakage${index}`} value={`${fields.leakage ?? ''}`} />
      </FormField>

      <FormField toolTipMessage={TOOLTIP.kB} isSkeleton={isLoading} label='K’/B’' labelId={`kB${index}`}>
        <ReadOnlyField isSkeleton={isLoading} labelledBy={`kB${index}`} value={`${fields.kB ?? ''}`} />
      </FormField>
    </>
  )
}
